export default function ServicesHero() {
  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden bg-[#0A0A0A]">
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center scale-105"
        style={{
          backgroundImage: "url('https://public.readdy.ai/ai/img_res/91e9e4e5bc608206ec62cfc0e0ca9c02.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/95 via-[#0A0A0A]/88 to-[#0A0A0A]/55" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 via-transparent to-[#050505]/40" />
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-[#FF6B35] to-transparent" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-44 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="flex flex-wrap items-center gap-3 mb-8">
              <span className="inline-flex items-center gap-2 border border-[#FF6B35]/50 bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-black uppercase tracking-widest px-4 py-2 rounded-full">
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-shield-star-fill text-xs" /></span>
                Premium Protection Services
              </span>
              <span className="inline-flex items-center gap-2 border border-white/15 text-white/60 text-xs font-semibold px-4 py-2 rounded-full">
                South Windsor, CT
              </span>
            </div>

            <h1 className="font-display font-black leading-[1.02] mb-6">
              <span className="block text-white" style={{ fontSize: 'clamp(2.2rem, 4.5vw, 4rem)' }}>
                Auto Protection &amp;
              </span>
              <span className="block text-[#FF6B35]" style={{ fontSize: 'clamp(2.5rem, 5vw, 4.5rem)' }}>
                Enhancement Services
              </span>
              <span className="block text-white" style={{ fontSize: 'clamp(1.8rem, 3.5vw, 3rem)' }}>
                in South Windsor, CT
              </span>
            </h1>

            <p className="text-white/80 text-lg leading-relaxed mb-2 max-w-xl">
              XPEL-certified PPF · Ceramic Coating · Window Tint · Matte Wraps · Windshield Film · Motorcycle Protection
            </p>
            <p className="text-white/50 text-base mb-10 max-w-lg">
              Every service is delivered with precision tools, premium materials, and 25+ years of automotive expertise. No shortcuts. Ever.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <a href="#lead-form"
                className="flex items-center justify-center gap-3 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-black text-base px-9 py-4 rounded-xl transition-all hover:scale-[1.02] whitespace-nowrap cursor-pointer"
                style={{ boxShadow: '0 10px 30px rgba(255,107,53,0.35)' }}>
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-check-fill text-lg" /></span>
                Get a Free Quote
              </a>
              <a href="tel:+18605550127"
                className="flex items-center justify-center gap-2 border-2 border-white/30 hover:border-white/70 hover:bg-white/10 text-white font-bold text-base px-8 py-4 rounded-xl transition-all whitespace-nowrap cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill" /></span>
                (860) 555-0127
              </a>
            </div>

            <div className="flex flex-wrap gap-x-8 gap-y-3">
              {[
                { icon: 'ri-award-fill', text: 'XPEL Certified' },
                { icon: 'ri-shield-star-fill', text: '10-Year PPF Warranty' },
                { icon: 'ri-car-fill', text: '500+ Vehicles Protected' },
                { icon: 'ri-star-fill', text: '5★ Google Rated' },
              ].map((b) => (
                <div key={b.text} className="flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center"><i className={`${b.icon} text-[#FF6B35] text-sm`} /></span>
                  <span className="text-white/65 text-sm font-medium whitespace-nowrap">{b.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 hidden lg:flex flex-col gap-4">
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-[#FF6B35]/15 rounded-xl">
                  <i className="ri-search-eye-line text-[#FF6B35] text-base" />
                </div>
                <p className="text-white font-bold text-sm">Which service is right for me?</p>
              </div>
              <p className="text-gray-400 text-xs leading-relaxed">
                PPF protects against physical damage like rock chips. Ceramic coating adds a hydrophobic, UV-resistant gloss. Many clients combine both for complete protection. Call us — we'll match you to the perfect package.
              </p>
            </div>
            <div className="grid grid-cols-3 gap-3">
              {[
                { icon: 'ri-shield-fill', label: 'PPF' },
                { icon: 'ri-sparkling-2-fill', label: 'Ceramic' },
                { icon: 'ri-sun-fill', label: 'Window Tint' },
                { icon: 'ri-paint-fill', label: 'Matte PPF' },
                { icon: 'ri-eye-fill', label: 'Windshield' },
                { icon: 'ri-motorbike-fill', label: 'Motorcycle' },
              ].map((s) => (
                <div key={s.label} className="bg-white/5 border border-white/10 rounded-xl px-3 py-3 flex flex-col items-center gap-2">
                  <span className="w-7 h-7 flex items-center justify-center bg-[#FF6B35]/15 rounded-lg flex-shrink-0">
                    <i className={`${s.icon} text-[#FF6B35] text-sm`} />
                  </span>
                  <span className="text-white/60 text-xs font-semibold text-center leading-tight">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 text-white/25 animate-bounce">
        <span className="text-xs uppercase tracking-[0.2em]">Explore</span>
        <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-down-line" /></span>
      </div>
    </section>
  );
}
